import cn from "classnames"

import { Button } from "@/atoms"
import { DownOutlined } from "@/icons"

import styles from "./ButtonQuickFilter.module.scss"

import type { ButtonQuickFilterProps } from "."

export const ButtonQuickFilter = (props: ButtonQuickFilterProps) => {
  const { children, bold, onClick } = props

  return (
    <Button type="text" onClick={onClick}>
      <div className={cn(styles.wrapper, bold && styles.wrapperBold)}>
        {children}
        <DownOutlined className={styles.icon} />
      </div>
    </Button>
  )
}
